var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isShow)?_c('div',{ref:"mask",staticClass:"mask"}):_vm._e(),_c('iframe',{attrs:{"src":"https://www.spsspro.com/analysis/index","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }